import {
  fontPretendard
} from "./chunk-UOJNIETM.mjs";

// src/font.style.ts
import { css } from "@emotion/react";
var heroTitle = css`
  font-family: ${fontPretendard};
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 52px;
`;
var largeTitle = css`
  font-family: ${fontPretendard};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px;
`;
var title1 = css`
  font-family: ${fontPretendard};
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
`;
var title2 = css`
  font-family: ${fontPretendard};
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
`;
var subTitle1 = css`
  font-family: ${fontPretendard};
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
`;
var subTitle2 = css`
  font-family: ${fontPretendard};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
`;
var subTitle3 = css`
  font-family: ${fontPretendard};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;
var bodyB = css`
  font-family: ${fontPretendard};
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
`;
var bodyCompact = css`
  font-family: ${fontPretendard};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
`;
var bodyM = css`
  font-family: ${fontPretendard};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
`;
var bodyLong = css`
  font-family: ${fontPretendard};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;
var captionSb = css`
  font-family: ${fontPretendard};
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;
var captionM = css`
  font-family: ${fontPretendard};
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
var tag1Sb = css`
  font-family: ${fontPretendard};
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
`;
var tag1M = css`
  font-family: ${fontPretendard};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;
var tag2 = css`
  font-family: ${fontPretendard};
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;

export {
  heroTitle,
  largeTitle,
  title1,
  title2,
  subTitle1,
  subTitle2,
  subTitle3,
  bodyB,
  bodyCompact,
  bodyM,
  bodyLong,
  captionSb,
  captionM,
  tag1Sb,
  tag1M,
  tag2
};
